var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.004,
    height: 20
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".calendar_svg__cls-4{fill:#ababab}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "calendar_svg__Group_682",
    "data-name": "Group 682",
    transform: "translate(-338.998 -367)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "calendar_svg__Subtraction_401",
    "data-name": "Subtraction 401",
    d: "M18575 13026h-18v-2a2 2 0 012-2v1a2 2 0 004 0v-1h6v1a2 2 0 004 0v-1a2 2 0 012 2v2z",
    transform: "translate(-18218 -12653.002)",
    fill: "#f73c3c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "calendar_svg__Subtraction_400",
    "data-name": "Subtraction 400",
    d: "M18579 13040h-14a2 2 0 01-2-2v-11h18v11a2 2 0 01-2 2z",
    transform: "translate(-18224 -12653)",
    fill: "#dadadc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "calendar_svg__Rectangle_723",
    "data-name": "Rectangle 723",
    transform: "translate(342 377)",
    d: "M0 0h4v4H0z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "calendar_svg__Rectangle_726",
    "data-name": "Rectangle 726",
    className: "calendar_svg__cls-4",
    width: 2,
    height: 4,
    rx: 1,
    transform: "translate(342 367)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "calendar_svg__Rectangle_727",
    "data-name": "Rectangle 727",
    className: "calendar_svg__cls-4",
    width: 2,
    height: 4,
    rx: 1,
    transform: "translate(352 367)"
  }))));
}
export default SvgCalendar;